import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./AuthContext";
import {  FaUserCircle } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';

function Header({ handleNavigation }) {
  const [brandMenuOpen, setBrandMenuOpen] = useState(false);
  const [suppilerMenuOpen, setSuppilerMenuOpen] = useState(false);
  const [colorMenuOpen, setColorMenuOpen] = useState(false);
  const [customerMenuOpen, setCustomerMenuOpen] = useState(false);
  const [purchaseMenuOpen, setPurchaseMenuOpen ] = useState(false);
  const [saleMenuOpen, setSaleMenuOpen] = useState(false);
  const [payableMenuOpen, setPayableMenuOpen] = useState(false);
const [dailyMenuOpen, setDailyOpen] = useState(false);
const [enquiryMenuOpen, setEnquiryOpen] = useState(false);
const [cashPurchaseMenuOpen, setCashPurchaseMenuOpen] = useState(false);
  const handleToggleBrandMenu = () => {
    setBrandMenuOpen(!brandMenuOpen);
  };

  const handleToggleSuppilerMenu = () => {
    setSuppilerMenuOpen(!suppilerMenuOpen);
  };

  const handleToggleColorMenu = () => {
    setColorMenuOpen(!colorMenuOpen);
  };

  const handleToggleCustomerMenu = () => {
    setCustomerMenuOpen(!customerMenuOpen);
  };

  const handleTogglePurchaseMenu = () => {
    setPurchaseMenuOpen(!purchaseMenuOpen);
  };

  const handleTogglePayableMenu = () => {
    setPayableMenuOpen(!payableMenuOpen);
  };

  const handleToggleSaleMenu = () => {
    setSaleMenuOpen(!saleMenuOpen);
  };

  const handleToggleDaily = () => {
    setDailyOpen(!dailyMenuOpen);
  };

  const handleToggleEnquiry = () => {
    setEnquiryOpen(!enquiryMenuOpen);
  };

  const handleToggleCashPurchaseMenu = () => {
    setCashPurchaseMenuOpen(!cashPurchaseMenuOpen);
  };
//logout
  const username = localStorage.getItem('username');
  const isLoggedIn=localStorage.getItem('isLoggedIn');
  const {
    handleLogout,

  }=useAuth();

  const logOut =()=>{

   handleLogout();

  }

  const navigate = useNavigate();
   const handleNavigate = (path) => {
    // Trigger the navigation confirmation
    handleNavigation(path);
  };
  return (
    <>
    <div id="header-open">
      <aside
        id="layout-menu"
        className="layout-menu menu-vertical menu bg-menu-theme"
      >
        <div className="app-brand">
          <a href="/" className="app-brand-link">
             <img src="assets/img/logo.png" style={{height:"100px", width:"100%", margin:"20px"}}/>
          </a>
          <a
            href="/"
            className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none"
          >
            <i className="txt-color txt-color bx bx-chevron-left bx-sm align-middle" />
          </a>
        </div>
        <div className="menu-inner-shadow" />
        <ul className="menu-inner py-1 scroll">
          <li className="menu-item">
            <Link to="/" className="menu-link main_menubg" onClick={() => handleNavigate('/')}>
              <i className="txt-color txt-color menu-icon tf-icons bx bx-home-circle txt-color" />
              <div className="txt-color" data-i18n="Analytics txt">Dashboard</div>
            </Link>
          </li>
          {username === 'admin' && (
          <li className="menu-item ">
            <Link to="/user" className="menu-link main_menubg" onClick={() => handleNavigate('/user')}>
              <FaUserCircle style={{ marginRight: "12px",color:"black" }} />
              <div className="txt-color" data-i18n="Analytics ">Manage User</div>
            </Link>
          </li>
          )}
          
          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Pages</span>
          </li>
         
         {/* <hr style={{height:"1px",color:"black",width:"261px"}}/> */}
        {username === 'admin' && (

          <li className={`menu-item ${suppilerMenuOpen ? "open" : ""}`}>
            <div
              className="menu-link menu-toggle1 main_menubg"
              onClick={handleToggleSuppilerMenu}
            >
              <i className='menu-icon bx bx-user' style={{color:"black"}}></i>
              <div className="txt-color" data-i18n="Layouts">Supplier Details</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item">
                <Link to="/suppiler" className="menu-link sub-background" onClick={() => handleNavigate('/suppiler')}>
                  <div className="txt-color" data-i18n="Without menu">Add Suppiler</div>
                </Link>
              </li>
              <li className="menu-item">
                <Link to="/suppiler_table" className="menu-link sub-background" onClick={() => handleNavigate('/suppiler_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Suppiler List</div>
                </Link>
              </li>
            </ul>
          </li>
           
           )}
          {username === 'admin' && (
          <li className={`menu-item ${purchaseMenuOpen ? "open" : ""}`}>
            <div
              className="menu-link menu-toggle1 main_menubg"
              onClick={handleTogglePurchaseMenu}
            >
              <i className="txt-color txt-color txt-color menu-icon bx bx-purchase-tag-alt" />
            
              <div className="txt-color" data-i18n="Layouts">Purchase Details</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item">
                <Link to="/purchase" className="menu-link sub-background" onClick={() => handleNavigate('/purchase')}>
                  <div className="txt-color" data-i18n="Without menu">Purchase</div>
                </Link>
              </li>
              <li className="menu-item">
                <Link to="/purchase_table" className="menu-link sub-background" onClick={() => handleNavigate('/purchase_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Purchase List</div>
                </Link>
              </li>
              {/* <li className="menu-item">
                <Link to="/purchase_invoice" className="menu-link">
                  <div className="txt-color" data-i18n="Without navbar">Purchase Invoice</div>
                </Link>
              </li> */}
            </ul>
          </li>
          )}
           {username !== 'admin' && (
          <li className={`menu-item ${saleMenuOpen ? "open" : ""}`} >
            <div
              className="menu-link menu-toggle1 main_menubg"
              onClick={handleToggleSaleMenu}
              style={{backgroundColor:"orange"}}>
              <i className="txt-color txt-color menu-icon bx bx-credit-card-front" />
              <div className="txt-color" data-i18n="Layouts">Bill Book</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item" >
                <Link to="/sale" className="menu-link sub-background" style={{backgroundColor:"gold"}} onClick={() => handleNavigate('/sale')}>
                  <div className="txt-color" data-i18n="Without menu" >Add Bill</div>
                </Link>
              </li> 
              <li className="menu-item">
                <Link to="/sale_table" className="menu-link sub-background" onClick={() => handleNavigate('/sale_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Bill List</div>
                </Link>
              </li>
              <li className="menu-item">
                <Link to="/sale_buyback_table" className="menu-link sub-background" onClick={() => handleNavigate('/sale_buyback_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Buy Back List</div>
                </Link>
              </li>
              
              {/* <li className="menu-item">
                <Link to="/invoice_sale" className="menu-link">
                  <div className="txt-color" data-i18n="Without navbar">Invoice Sale</div>
                </Link>
              </li> */}
            </ul>
          </li>
           )}
           {username !== 'admin' && (
          <li className={`menu-item ${cashPurchaseMenuOpen ? "open" : ""}`}>
            <div
              className="menu-link menu-toggle1 main_menubg"
              onClick={handleToggleCashPurchaseMenu}
            >
              <i className="txt-color txt-color menu-icon bx bx-money" />
              <div className="txt-color" data-i18n="Layouts">Cash Purchase</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item">
                <Link to="/cash_purchase" className="menu-link sub-background" onClick={() => handleNavigate('/cash_purchase')}>
                  <div className="txt-color" data-i18n="Without menu">Add Cash Purchase</div>
                </Link>
              </li>
              <li className="menu-item">
                <Link to="/cash_purchase_table" className="menu-link sub-background" onClick={() => handleNavigate('/cash_purchase_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Cash Purchase List</div>
            </Link>
              </li>
            </ul>
          </li>
           )}
           {username !== 'admin' && (
          <li className="menu-item">
            <Link to="/PurchaseList_for_user" className="menu-link main_menubg" onClick={() => handleNavigate('/purchase_table')}>
              <i className="txt-color txt-color menu-icon tf-icons bx bx-layout" />
              <div className="txt-color" data-i18n="Layouts">Model Inventory</div>
            </Link>
          </li>
           )}
           {username !== 'admin' && (
          <li className={`menu-item ${enquiryMenuOpen ? 'open' : ''}`}>
            <div className="menu-link menu-toggle1 main_menubg" onClick={handleToggleEnquiry}>
            <i
                className="menu-icon bx bxs-book-open txt-color"
               
              />
              <div className="txt-color" data-i18n="Layouts">Enquiry Details</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item">
                <Link to="/enquiry" className="menu-link sub-background" onClick={() => handleNavigate('/enquiry')}>
                  <div className="txt-color" data-i18n="Without menu">Add Enquiry</div>
                </Link>
              </li>
              <li className="menu-item">

                <Link to="/enquirylist" className="menu-link sub-background" onClick={() => handleNavigate('/enquirylist')}>
                  <div className="txt-color" data-i18n="Without navbar">Enquiry List</div> 
                </Link>

              </li>
            </ul>
          </li>
          )}
           {username !== 'admin' && (
          <li className={`menu-item ${colorMenuOpen ? 'open' : ''}`}>
          <div className="menu-link menu-toggle1 main_menubg" onClick={handleToggleColorMenu}>
            <i className="txt-color txt-color menu-icon bx bx-wallet" />
            <div className="txt-color" data-i18n="Layouts">Expenses</div>
          </div>
          <ul className="menu-sub">
            <li className="menu-item">
              <Link to="/Expenses" className="menu-link sub-background" onClick={() => handleNavigate('/Expenses')}>
                <div className="txt-color" data-i18n="Without menu">Add Expnse</div>
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/ExpensesList" className="menu-link sub-background" onClick={() => handleNavigate('/ExpensesList')}>
                <div className="txt-color" data-i18n="Without navbar">Expense List</div>
              </Link>
            </li>
          </ul>
        </li>
          )}
          {username !== 'admin' && (
          <li className={`menu-item ${brandMenuOpen ? "open" : ""}`}>
            <div
              className="menu-link menu-toggle1 main_menubg"
              onClick={handleToggleBrandMenu}
            >
              <i className="txt-color txt-color menu-icon tf-icons bx bx-layout" />
              <div className="txt-color" data-i18n="Layouts">Model Details</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item">
                <Link to="/model" className="menu-link sub-background" onClick={() => handleNavigate('/model')}>
                  <div className="txt-color" data-i18n="Without menu">Model</div>
                </Link>
              </li>
              <li className="menu-item">
                <Link to="/model_table" className="menu-link sub-background" onClick={() => handleNavigate('/model_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Model List</div>
                </Link>
              </li>
            </ul>
          </li>
          )}
          {username === 'admin' && (
          <li className={`menu-item ${payableMenuOpen ? 'open' : ''}`}>
            <div className="menu-link menu-toggle1 main_menubg" onClick={handleTogglePayableMenu}>
              <i className="txt-color txt-color menu-icon bx bx-wallet" />
              <div className="txt-color" data-i18n="Layouts">Purchase Payable</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item">
                <Link to="/purchase_payable" className="menu-link sub-background" onClick={() => handleNavigate('/purchase_payable')}>
                  <div className="txt-color" data-i18n="Without menu">Purchase Payable</div>
                </Link>
              </li>
              <li className="menu-item">
                <Link to="/purchase_payable_table" className="menu-link sub-background" onClick={() => handleNavigate('/purchase_payable_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Purchase Payable List</div>
                </Link>
              </li>
            </ul>
          </li>
           )}
           {/* {username === 'admin' && (
          <li className={`menu-item ${saleMenuOpen ? 'open' : ''}`}>
            <div className="menu-link menu-toggle1 main_menubg" onClick={handleToggleSaleMenu}>
              <i className="txt-color txt-color menu-icon bx bx-wallet" />
              <div className="txt-color" data-i18n="Layouts">Sale Payable</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item">
                <Link to="/sale_payable" className="menu-link sub-background" onClick={() => handleNavigate('/sale_payable')}>
                  <div className="txt-color" data-i18n="Without menu">Sale Payable</div>
                </Link>
              </li>
              <li className="menu-item">
                <Link to="/sale_payable_table" className="menu-link sub-background" onClick={() => handleNavigate('/sale_payable_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Sale Payable List</div>
                </Link>
              </li>
            </ul>
          </li>
           )} */}
          {username === 'admin' && (
          <li className={`menu-item ${customerMenuOpen ? "open" : ""}`}>
            <div
              className="menu-link menu-toggle1 main_menubg"
              onClick={handleToggleCustomerMenu}
            >
              <i className="txt-color txt-color menu-icon bx bx-detail" />
              <div className="txt-color" data-i18n="Layouts">Leager Details</div>
            </div>
           
            <ul className="menu-sub">
              
              <li className="menu-item">
                <Link to="/supplier_leager_table" className="menu-link sub-background" onClick={() => handleNavigate('/supplier_leager_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Suppiler Leager</div>
                </Link>
              </li>
              {/* <li className="menu-item">
                <Link to="/dailybook_leager_list" className="menu-link sub-background" onClick={() => handleNavigate('/dailybook_leager_list')}>
                  <div className="txt-color" data-i18n="Without navbar">Dailybook Leager</div>
                </Link>
              </li>
              <li className="menu-item">
                <Link to="/general_leager_table" className="menu-link sub-background" onClick={() => handleNavigate('/general_leager_table')}>
                  <div className="txt-color" data-i18n="Without navbar">General Leager</div>
                </Link>
              </li> */}
              
            </ul>


          </li>
          )}
           {/* {username !== 'admin' && ( 
          <li className={`menu-item ${dailyMenuOpen ? 'open' : ''}`}>
            <div className="menu-link menu-toggle1 main_menubg" onClick={handleToggleDaily}>
            <i
                className="menu-icon bx bxs-book-open txt-color"
               
              />
              <div className="txt-color" data-i18n="Layouts">Daily Book</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item">
                <Link to="/dailybook" className="menu-link sub-background" onClick={() => handleNavigate('/dailybook')}>
                  <div className="txt-color" data-i18n="Without menu">Daily Book</div>
                </Link>
              </li>
              <li className="menu-item">

                <Link to="/dailybook_list" className="menu-link sub-background" onClick={() => handleNavigate('/dailybook_list')}>
                  <div className="txt-color" data-i18n="Without navbar">Daily Book List</div> 
                </Link>

              </li>
            </ul>
          </li>
           )} */}
          {username === 'admin' && (
          <li className={`menu-item ${brandMenuOpen ? "open" : ""}`}>
            <div
              className="menu-link menu-toggle1 main_menubg"
              onClick={handleToggleBrandMenu}
            >
              <i className="txt-color txt-color menu-icon tf-icons bx bx-layout" />
              <div className="txt-color" data-i18n="Layouts">Model Details</div>
            </div>
            <ul className="menu-sub">
              <li className="menu-item">
                <Link to="/model" className="menu-link sub-background" onClick={() => handleNavigate('/model')}>
                  <div className="txt-color" data-i18n="Without menu">Model</div>
                </Link>
              </li>
              <li className="menu-item">
                <Link to="/model_table" className="menu-link sub-background" onClick={() => handleNavigate('/model_table')}>
                  <div className="txt-color" data-i18n="Without navbar">Model List</div>
                </Link>
              </li>
            </ul>
          </li>
          )}
           
           {username === 'admin' && (
          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Reports</span>
          </li>)}
          {username === 'admin' && (
          <li className="menu-item ">
            <Link to="/purchase_report" className="menu-link main_menubg" onClick={() => handleNavigate('/purchase_report')}>
            
            <i className='bx bxs-purchase-tag-alt txt-color'style={{ marginRight: "12px" }} ></i>
              <div className="txt-color" data-i18n="Analytics ">Purchase Report</div>
            </Link>
          </li>)}
          {username === 'admin' && (
          <li className="menu-item ">
            <Link to="/sale_report" className="menu-link main_menubg" onClick={() => handleNavigate('/sale_report')}>
            
            <i className='bx bxs-credit-card-front' style={{ marginRight: "12px",color:"black" }} />
              <div className="txt-color" data-i18n="Analytics">Sale Report</div>
            </Link>
          </li>)}
          {username === 'admin' && (
          <li className="menu-item ">
            <Link to="/todayProfit" className="menu-link main_menubg" onClick={() => handleNavigate('/todayProfit')}>
            
            <i className='bx bxs-credit-card-front' style={{ marginRight: "12px", color:"black" }} />
              <div className="txt-color" data-i18n="Analytics ">Daily Profit</div>
            </Link>
          </li>)}
          {username === 'admin' && (
          <li className="menu-item ">
            <Link to="/daily_stock" className="menu-link main_menubg" onClick={() => handleNavigate('/daily_stock')}>
            
            <i className='bx bxs-book-open' style={{ marginRight: "12px", color:"black" }} />
              <div className="txt-color" data-i18n="Analytics ">Daily Tally</div>
            </Link>
          </li>)}
          {username === 'admin' && (
          <li className="menu-item ">
            <Link to="/imei_transactions" className="menu-link main_menubg" onClick={() => handleNavigate('/imei_transactions')}>
            
            <i className='bx bx-mobile-alt' style={{ marginRight: "12px", color:"black" }} />
              <div className="txt-color" data-i18n="Analytics ">IMEI Transactions</div>
            </Link>
          </li>)}
          
          {username !== 'admin' && (
          <li className="menu-header small text-uppercase">
            <span className="menu-header-text">Reports</span>
          </li>)}
          {username !== 'admin' && (
          <li className="menu-item ">
            <Link to="/daily_stock" className="menu-link main_menubg" onClick={() => handleNavigate('/daily_stock')}>
            
            <i className='bx bxs-book-open' style={{ marginRight: "12px", color:"black" }} />
              <div className="txt-color" data-i18n="Analytics ">Daily Tally</div>
            </Link>
          </li>)}

          <li className="menu-header small text-uppercase" style={{marginTop:"0px", marginBottom:"0px"}}>
          <hr style={{backgroundColor:"white",height:"2px",width:"100px"}}/>
          </li>
           
          {isLoggedIn === 'true' && (
            
  <li className="menu-item active">
   
    <div to="/" className="menu-link">
     
    
      <div className="txt-color" data-i18n="Analytics " onClick={logOut}>
      <i className="txt-color txt-color bx bx-power-off me-2 " style={{ marginRight: "12px" ,color:"red"}} />
        Logout
      </div>
    </div>
  </li>
)}

          
        </ul>
      </aside>
      </div>
    </>
    
  );
}

export default Header;
